module.exports = __webpack_public_path__ + "media/images/homes/product_customer_search-bbcf7adc3b443b00f0f45eb6608f16e1.png";